import { GetContent } from '../components'

const Home = () => {
    return <GetContent/>
};

export default Home;
